import { useDataStore } from '@/lib/machine/use-data-store'
import { useBattery } from '@uidotdev/usehooks'
import {
  BatteryChargingIcon,
  BatteryFullIcon,
  BatteryLowIcon,
  BatteryMediumIcon
} from 'lucide-react'

export const BatteryStatus = () => {
  const isConnected = useDataStore(s => s.isConnected)
  const reportedBattery = useDataStore(s => s.refreshData?.BATTERY)
  const browserBattery = useBattery()
  const battery = isConnected ? reportedBattery : undefined
  const charging = battery?.[0] ?? browserBattery.charging
  const level = battery ? battery[1] / 100 : browserBattery.level

  if (!battery && browserBattery.loading) return null

  return (
    <div className="flex items-center gap-2 select-none">
      {charging ? (
        <BatteryChargingIcon />
      ) : level === null ? (
        <BatteryFullIcon />
      ) : level < 0.33 ? (
        <BatteryLowIcon />
      ) : level < 0.66 ? (
        <BatteryMediumIcon />
      ) : (
        <BatteryFullIcon />
      )}
      {level !== null && <span className="text-lg">{(level * 100).toFixed(0)}%</span>}
    </div>
  )
}
